import { Repeat } from "lucide-react";
import { useTranslations } from "use-intl";

export function ReturnTripBanner() {
  const t = useTranslations("workOrder.details");

  return (
    <div className="mt-4 flex items-center gap-3 rounded-lg border border-dashed border-teal-300 bg-teal-50 p-3">
      <span className="rounded bg-teal-600 px-2 py-1 text-xs font-bold uppercase tracking-wide text-white">
        {t("returnTrip")}
      </span>
      <div className="flex items-center gap-1.5 text-sm text-teal-800">
        <Repeat className="size-4 text-teal-600" />
        {t("hasReturnTrip")}
      </div>
    </div>
  );
}
